import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { View } from "react-native";

export default function IconWrapper({icon, color, size, style}) {
	return (
		<View pointerEvents="none">
			<FontAwesomeIcon icon={icon} color={color} size={size} style={style} />
		</View>
	);
}
